module.exports = __webpack_public_path__ + "img/pasos1-2.8f509ebb.png";